<template>
  <div class="top-chart-serie" @click="toggleCheckbox">
    <v-checkbox :inputValue="state" />
    <span
      class="top-chart-serie__color"
      :style="{ 'background-color': color }"
    ></span>
    <p>{{ label }}</p>
  </div>
</template>

<script>
import { TOP_CHART_SERIE } from "@/enums/charts-type.enum";

export default {
  name: "TopChartSerieCheckbox",
  props: {
    state: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true,
      validator: val => Object.values(TOP_CHART_SERIE).includes(val)
    },
    color: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleCheckbox() {
      this.$emit("toggle", this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.top-chart-serie {
  display: flex;
  align-items: center;
  padding-left: $spacing * 0.4;
  padding-right: $spacing;
  margin-right: auto;
  cursor: pointer;

  &__color {
    min-width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-left: $spacing * 0.25;
    margin-right: $spacing;
  }

  p {
    margin-bottom: 0;
    @include font-size(14px);
    line-height: 1.24;
  }
}
</style>
